import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { ThemeProvider } from 'next-themes';

import { BeltProvider } from "../../contexts/BeltContext";
import CustomerPortal from "../../components/customer/CustomerPortal";
import CustomerLogin from "../../components/customer/CustomerLogin";
import MagicLinkVerify from "../../components/customer/MagicLinkVerify";
import ImpersonationVerify from "../../components/customer/ImpersonationVerify";
import ResourceLinkRouter from "../../components/customer/ResourceLinkRouter";
import PaymentSuccess from "../../components/customer/PaymentSuccess";
import PaymentCancelled from "../../components/customer/PaymentCancelled";
import ReviewRedirect from "../../components/public/ReviewRedirect";
import PwaUpdateToast from "../../components/shared/PwaUpdateToast";

// Redirect component that preserves query parameters
const RedirectWithQuery = ({ to }) => {
  const [searchParams] = useSearchParams();
  const queryString = searchParams.toString();
  const destination = queryString ? `${to}?${queryString}` : to;
  return <Navigate to={destination} replace />;
};

function MembersApp() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <BeltProvider>
        <div className="App">
          <BrowserRouter>
          <Routes>
          {/* Members portal routes */}
          <Route path="/" element={<CustomerPortal />} />
          <Route path="/login" element={<CustomerLogin />} />
          <Route path="/verify" element={<MagicLinkVerify />} />
          {/* Also support /account/verify path for magic links */}
          <Route path="/account/verify" element={<MagicLinkVerify />} />
          {/* Resource link deep linking */}
          <Route path="/r/:shortCode" element={<ResourceLinkRouter />} />
          {/* Admin impersonation route */}
          <Route path="/impersonate" element={<ImpersonationVerify />} />
          {/* Google review funnel (linked from the member dashboard review banner) */}
          <Route path="/review" element={<ReviewRedirect />} />
          {/* Payment routes */}
          <Route path="/account/payment-success" element={<PaymentSuccess />} />
          <Route path="/account/payment-cancelled" element={<PaymentCancelled />} />
          {/* Redirect old paths */}
          <Route path="/account" element={<Navigate to="/" replace />} />
          <Route path="/account/login" element={<Navigate to="/login" replace />} />
          </Routes>
          <PwaUpdateToast variant="member" />
        </BrowserRouter>
      </div>
    </BeltProvider>
    </ThemeProvider>
  );
}

export default MembersApp;
